import React from 'react'
import ConfigureIcon from '../../../../../src/assets/icons/dasboardIcons/configure-icon.svg';

import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import GridArea from './Widgets/GridArea';

const DashBoardBody = ({ dashboardWidgets, label, handleAddWidget, handleOpenRemoveWidget, openConfigure, dateShowValue, customDateValue, moveWidget }) => {
    const { t } = useTranslation();

    const gridItems = [
        // {
        //     content: {
        //         name: "heat_map_chart",
        //         data: {
        //             values: [
        //                 { date: '2021-05-02', count: 3 },
        //                 { date: '2021-05-05', count: 2 },
        //                 { date: '2021-05-06', count: 1 },
        //                 { date: '2021-05-07', count: 2 },
        //                 { date: '2021-06-05', count: 3 },
        //                 { date: '2021-06-11', count: 2 },
        //                 { date: '2021-06-16', count: 3 },
        //                 // { date: '2021-11-03', count: 4 },
        //                 // Diğer tarihleri ve sayıları buraya ekleyin
        //             ],
        //         }
        //     }, cols: 2, rows: 2
        // },
    ];


    return (<>
        {
            <GridArea items={dashboardWidgets} label={label} handleAddWidget={handleAddWidget} handleOpenRemoveWidget={handleOpenRemoveWidget}
                openConfigure={openConfigure} dateShowValue={dateShowValue} customDateValue={customDateValue} moveWidget={moveWidget} />
        }
    </>
    )
}

export default DashBoardBody